import type { ReactNode } from 'react';
import React, { useState } from 'react';
import { Space, Input, Button, message, Card } from 'antd';
import { UpdateOrganizationRegistration } from '../../helper/apiHelper';
import { useTranslation } from 'react-i18next';
import styles from '../../Assets/Styles/Global.module.css';

interface OrganizationRegistrationFormProps {
  registrationId: number;
  onRegistration?: () => Promise<void>;
}

const OrganizationRegistrationForm = ({
  registrationId,
  onRegistration,
}: OrganizationRegistrationFormProps): ReactNode => {
  const { t } = useTranslation();
  const [registrationNumber, setRegistrationNumber] = useState('');
  const [registrationDate, setRegistrationDate] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (): Promise<void> => {
    if (!registrationNumber || !registrationDate) {
      message.error(t('legDepComp.fillRequiredFields'));
      return;
    }

    setLoading(true);
    try {
      await UpdateOrganizationRegistration(registrationId, {
        registrationNumber,
        registrationDate,
      });
      if (onRegistration) {
        await onRegistration();
      }
      message.success(t('legDepComp.registrationSuccess'));
    } catch (e) {
      console.error(e);
      message.error(t('legDepComp.registrationError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      title={t('legDepComp.registerCollaboration')}
      style={{ width: '100%', margin: '16px 0', backgroundColor: '#f0f2f5' }}
      size="small"
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <Input
          placeholder={t('legDepComp.registrationNumber')}
          type="number"
          value={registrationNumber}
          onChange={(e) => setRegistrationNumber(e.target.value)}
          onWheel={(e) => (e.target as HTMLInputElement).blur()}
          className={styles.noSpinners}
        />

        <Input
          type="date"
          style={{ width: '100%' }}
          value={registrationDate}
          onChange={(e) => setRegistrationDate(e.target.value)}
        />

        <Button type="primary" loading={loading} onClick={handleSubmit}>
          {t('legDepComp.saveRegistration')}
        </Button>
      </Space>
    </Card>
  );
};

export default OrganizationRegistrationForm;
